import React from 'react';

import i18n from 'i18next';

import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import XIcon from '@mui/icons-material/X';

import copyToClipboard from './copyToClipboard';

export default (videoTitle) => {
  const encodedUrl = encodeURIComponent(window.location.href);
  const encodedTitle = encodeURIComponent(videoTitle);

  return [
    {
      ariaLabel: i18n.t('share-on', { platform: 'X' }),
      icon: <XIcon />,
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`
    }, {
      ariaLabel: i18n.t('share-on', { platform: 'Facebook' }),
      icon: <FacebookOutlinedIcon />,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
    }, {
      ariaLabel: i18n.t('share-on', { platform: 'LinkedIn' }),
      icon: <LinkedInIcon />,
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`
    }, {
      ariaLabel: i18n.t('copy-to-clipboard'),
      icon: <LinkOutlinedIcon />,
      onClick: () => copyToClipboard(window.location.href),
    }
  ];
};
